import Vue from 'vue'
import axios from 'axios'
import store from './store'


const apiCall = {
	install(Vue) {
		Vue.prototype.$apiCall = async function(query, variables, doNotShowErrors = false) {
      const accessToken = await Vue.prototype.$auth.getTokenSilently();

      const response = !accessToken ||
                        await axios.post(`${process.env.VUE_APP_PORTAL_API}/${store.state.companyId?store.state.companyId:''}`,
                                        {query, variables},
                                        { headers: {Authorization: `Bearer ${accessToken}`}, validateStatus: () => {return true}});
      if (!accessToken || response.status === 401 || response.status === 500) { // Invalid token - clear user info
        store.commit('clearUser');
        Vue.prototype.$auth.login();
        return {error:true};
      }

      let error = null;
      if (response.data.errors) {
        const extensions = response.data.errors[0].extensions
        if (extensions && extensions.code === 'GRAPHQL_VALIDATION_FAILED') {
          console.error(response.data.errors);
          error = `It looks like something went wrong internally. We logged the problem and will look into it ASAP.`;

          // We want to know internally what is going on
          await axios.post(`${process.env.VUE_APP_PURTRAK_API}/${store.state.companyId?store.state.companyId:''}`,
                                        {query:`mutation ClientError($input:ClientErrorInput!) {
                                                  logClientError(input:$input)
                                                }`,
                                        variables:{input:{query, variables:JSON.stringify(variables), error:response.data.errors[0].message}}},
                                        {headers: {Authorization: `Bearer ${accessToken}`}, validateStatus: () => {return true}});
        }
        else if (extensions && extensions.code === 'INTERNAL_SERVER_ERROR') {
          error = `Oops. It looks like something went wrong internally. This is our fault and we'll look into it immediately.`;
          console.error(response.data.errors);
        }
        else
          error = response.data.errors[0].message;
      }
      if (error == null)
        error = response.data.error;
      if (error && !doNotShowErrors && this.$store)
        store.commit('setError', {type:'error',message:error});
      if (response.status === 400)
        console.error(error);

      const result = {data:response.data.data};
      if (error)
        result.error = {message:error};
      return result;
		}
	}
}

Vue.use(apiCall);
